import { useState } from "react";

import Icon from "../Icon";
import NavModal from "../Modal/NavModal";
import { GuestPass } from ".";
import SharePassByCode from "./SharePassByCode";
import SharePassByEmail from "./SharePassByEmail";
import SharePassBySMS from "./SharePassBySMS";

export enum ShareType {
  Email = "email",
  SMS = "sms",
  Code = "code",
}

export type GuestPassShareModalProps = {
  pass: GuestPass;
  isOpen: boolean;
  shareSuccess: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

const iconStyles = {
  width: "20px",
  height: "20px",
  className: "mb-2",
};

export const GuestPassShareModal = (props: GuestPassShareModalProps) => {
  const { pass, isOpen, shareSuccess, setIsOpen } = props;

  const [shareType, setShareType] = useState<ShareType | undefined>(undefined);
  const [shareStep, setShareStep] = useState<number>(0);

  const shareTypeClick = (st: ShareType) => {
    setShareType(st);
    setShareStep(1);
  };

  const onComplete = () => {
    shareSuccess();
    setIsOpen(false);
  };

  const backNav = () => {
    if (shareStep === 0) {
      onComplete();
    } else if (shareStep === 1) {
      setShareStep(0);
    }
  };

  const passTypeName = pass.name?.replace("Passes", "");

  return (
    <NavModal open={isOpen} onClose={onComplete} backNavClick={backNav}>
      <div className="mb-6 mt-2 inline-block items-center justify-between rounded-md border border-solid border-clear-sky p-2">
        {passTypeName}
      </div>
      <div className={"pb-6"}>
        {shareStep === 0 && (
          <div className="size-full px-10 pt-2">
            <div className="text-center font-poppins text-xl">
              How would you like to share your Guest Pass?
            </div>
            <div className="my-4 flex items-center justify-between text-center">
              <div
                className="my-4"
                onClick={() => shareTypeClick(ShareType.Email)}
              >
                <div className="rounded-3xl border border-solid border-clear-sky p-2">
                  <Icon style={iconStyles} name="envelope"></Icon>
                </div>
                <button className="text-sm">Email</button>
              </div>
              <div
                className="my-4"
                onClick={() => shareTypeClick(ShareType.SMS)}
              >
                <div className="rounded-3xl border border-solid border-clear-sky p-2">
                  <Icon style={iconStyles} name="commentBubble"></Icon>
                </div>
                <button className="text-sm">SMS</button>
              </div>
              <div
                className="my-4"
                onClick={() => shareTypeClick(ShareType.Code)}
              >
                <div className="rounded-3xl border border-solid border-clear-sky p-2">
                  <Icon style={iconStyles} name="copy"></Icon>
                </div>
                <button className="text-sm">Code</button>
              </div>
            </div>
          </div>
        )}
        {shareStep === 1 && (
          <>
            {shareType === ShareType.Code && <SharePassByCode pass={pass} />}
            {shareType === ShareType.Email && (
              <SharePassByEmail pass={pass} onComplete={onComplete} />
            )}
            {shareType === ShareType.SMS && (
              <SharePassBySMS pass={pass} onComplete={onComplete} />
            )}
          </>
        )}
      </div>
    </NavModal>
  );
};
